const Style = {
  auth: "bg-[#07101B] text-white min-h-screen lg:flex lg:justify-between",
};

export default Style;
